<template>
  <v-card>
     <v-dialog v-model="dialogAddCar" persistent max-width="600px">
      <v-card class="text-center">
        <v-card-title>
          <v-text-field
            label="Numer rejestracyjny"
            v-model="new_nr_rej"
            :rules="[isExist]"

          ></v-text-field>
        </v-card-title>
        <v-flex>
           <v-btn
            @click="dialogAddCar = false"
          text
          >
            {{$t("close")}}
          </v-btn>
          <v-btn
            color="red"
            text
            :disabled="isExist()"
            @click="addcar()"
          >
            {{$t("add")}}
          </v-btn>
       </v-flex>
      </v-card>
     </v-dialog>
    <v-toolbar  dense color="transparent">
      <v-toolbar-title><h4>Pojazdy</h4></v-toolbar-title>
      <v-spacer></v-spacer>
       <v-btn @click="deleteon = !deleteon" icon>
        <v-icon>remove</v-icon>
      </v-btn>
      <v-btn @click="dialogAddCar = true" icon>
        <v-icon>add</v-icon>
      </v-btn>
    </v-toolbar>
    <v-divider></v-divider>
    <v-card-text class="pa-0">
      <template>
        <v-data-table no-data-text="Brak rekordów" :mobile-breakpoint='200'  hide-default-header  :items-per-page=1000 :headers="headers" :items="itemsCars" hide-default-footer class="elevation-0">
           <template v-slot:item.nr_rej="{ item }">{{item.nr_rej}}
         <div v-if="deleteon" class="text-xs-right"><v-btn @click="deletecar(item.nr_rej)" text small icon ><v-icon>delete_outline</v-icon></v-btn></div>

    </template>-->
        </v-data-table>
      </template>
      <v-divider></v-divider>
    </v-card-text>
  </v-card>
</template>
<script>
const axios = require('axios');
import moment from 'moment'
export default {
   computed: {
    allcars(){
      return this.store.state.allcars;
    },
      datenow(){
      return this.store.state.dateNow
    },
    sortby(){
      return this.store.state.sortby
    }
  },
  watch:{
      sortby: {
      handler: function(newValue,oldValue) {
      this.sort = newValue;
      },
      deep: true
    },
     allcars: {
      handler: function(newValue) {
      this.itemsCars = newValue;

      },
      deep: true
    },
     datenow: {
      handler: function(newValue) {
      this.dateNow = newValue;

      },
      deep: true,
    }
  },
  data() {
    return {
      headers: [
        { text: "Rejestracja", value: "nr_rej"}
    
      ],
      itemsCars: this.store.state.allcars || [],
      dialogAddCar:false,
      new_nr_rej:null,
      sort:this.store.state.sortby,
      deleteon:false,
      dateNow:this.store.state.dateNow,
      pagination:{'sortBy': 'to_key', 'descending': true, 'rowsPerPage': 100,},
    }
  },
  mounted(){
  },
  methods: {
    driveCheck(arrive,left){
      let now = moment().utc();
      let arrived = moment(arrive);
      let lefted = moment(left);
      if(now < arrived){return true}
        else{ return false }
    },

      driveCheckReverse(arrive,left){
      let now = moment().utc();
      let arrived = moment(arrive);
      let lefted = moment(left);
      if(now > arrived){return true}
        else{ return false }
    },

    converttime(arrived,lefted) {
    let now = moment().utc();
    let arrive = moment(arrived)
    let left =  moment(lefted)
     let  alltimedrive = left.diff(arrive,'hours');
     let realtimedrive = now.diff(left,'hours');
      if(Math.abs(Math.floor( realtimedrive / alltimedrive  * 100))>0)return  Math.abs(Math.floor( realtimedrive / alltimedrive  * 100))
        else return 0
  },
    getCookie(cname){
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' '){
            c = c.substring(1);
        }
 
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
    },
    refresh(){
  var data = this;
  var jwt = this.getCookie('jwt');
  axios.post('http://' + location.hostname + '/transportapp/php_file/validation_token.php', {
           jwt :jwt,
           data:data.dateNow,
           sortby:data.sort
    })
  .then(function (response) {
    if ( response.data.message == "access" ){
     data.store.state.routes = JSON.parse(response.data.routes);
      data.store.state.cars = JSON.parse(response.data.cars);
          data.store.state.places = JSON.parse(response.data.places);
          data.store.state.allcars = JSON.parse(response.data.allcars)
    } else if ( response.data.message == "denied" ) {
        data.$router.push('/auth/login');
    }
  })
 },
   isExist(){
   if(this.new_nr_rej){ 
   if(this.allcars .some(car => car.nr_rej === this.new_nr_rej)){
        return true
    } else{
        return false
          
    }
  }
   },
     addcar(){
     var data=this;
     var jwt = this.getCookie('jwt');
     axios.post('http://'+location.hostname+'/transportapp/php_file/addcar.php', {
           jwt :jwt,
           nr_rej: data.new_nr_rej
    })
     .then(function (response) {
      console.log(response)
      data.newRoute = {};
      data.dialogAddCar = false;
      data.refresh();
      data.new_nr_rej=null;
    
     })
     .catch(function (error) {
       console.log(error);
     });
},
 deletecar(value){
     var data=this;
     var jwt = this.getCookie('jwt');
     axios.post('http://'+location.hostname+'/transportapp/php_file/deletecar.php', {
           jwt :jwt,
           nr_rej: value
    })
     .then(function (response) {
      data.refresh();
    
     })
     .catch(function (error) {
       console.log(error);
     });
    
},
  }
}
</script>
